import { EThemeKey } from '@constants';

export const AcademyDetailTranslations = {
  EDIT: {
    es: 'Editar',
    en: 'Edit',
    cat: 'Editar',
    eus: 'Editatu',
    pt: 'Editar'
  },
  ACADEMY: {
    es: 'Academia',
    en: 'Academy',
    cat: 'Acadèmia',
    eus: 'Akademia',
    pt: 'Académia'
  },
  BASIC_INFO: {
    es: 'Información básica',
    en: 'Basic information',
    cat: 'Informació bàsica',
    eus: 'Oinarrizko informazioa',
    pt: 'Informação básica'
  },
  CONFIG_INFO: {
    es: 'Configuración',
    en: 'Configuration',
    cat: 'Configuració',
    eus: 'Konfigurazioa',
    pt: 'Configuração'
  },
  ONBOARDING_SELECTOR: {
    es: 'Seleccionar onboarding',
    en: 'Select onboarding',
    cat: 'Seleccionar onboarding',
    eus: 'Onboarding hautatu',
    pt: 'Selecionar informação de onboarding'
  },
  SELECT_ONBOARDING_PLACEHOLDER: {
    es: 'Selecciona el onboarding',
    en: 'Select the onboarding',
    cat: 'Selecciona el onboarding',
    eus: 'Onboarding hautatu',
    pt: 'Seleciona o onboarding'
  },
  CONTACT_INFO: {
    es: 'Información de contacto',
    en: 'Contact information',
    cat: 'Informació de contacte',
    eus: 'Kontaktu informazioa',
    pt: 'Informação de contacto'
  },
  SOCIAL_MEDIA: {
    es: 'Redes sociales',
    en: 'Social media',
    cat: 'Redes socials',
    eus: 'Sare sozialak',
    pt: 'Redes sociais'
  },
  ONBOARDING_INFO: {
    es: 'Onboarding',
    en: 'Onboarding',
    cat: 'Onboarding',
    eus: 'Onboarding',
    pt: 'Onboarding'
  },
  NAME: {
    es: 'Nombre',
    en: 'Name',
    cat: 'Nom',
    eus: 'Izena',
    pt: 'Nome'
  },
  SLUG: {
    es: 'Slug',
    en: 'Slug',
    cat: 'Slug',
    eus: 'Slug',
    pt: 'Slug'
  },
  DOMAIN: {
    es: 'Dominio',
    en: 'Domain',
    cat: 'Dominio',
    eus: 'Dominio',
    pt: 'Dominio'
  },
  CERTIFICATE_URL: {
    es: 'URL del certificado',
    en: 'Certificate URL',
    cat: 'URL del certificado',
    eus: 'Certificado URL',
    pt: 'URL do certificado'
  },
  DESCRIPTION: {
    es: 'Descripción',
    en: 'Description',
    cat: 'Descripció',
    eus: 'Deskribapena',
    pt: 'Descrição'
  },
  CREATED_AT: {
    es: 'Fecha de creación',
    en: 'Created at',
    cat: 'Data de creació',
    eus: 'Sortze data',
    pt: 'Data de criação'
  },
  UPDATED_AT: {
    es: 'Última actualización',
    en: 'Last updated',
    cat: 'Última actualització',
    eus: 'Azken eguneratze data',
    pt: 'Última atualização'
  },
  WEBSITE: {
    es: 'Sitio web',
    en: 'Website',
    cat: 'Sitio web',
    eus: 'Webgunea',
    pt: 'Website'
  },
  ADDRESS: {
    es: 'Dirección',
    en: 'Address',
    cat: 'Adreça',
    eus: 'Helbidea',
    pt: 'Endereço'
  },
  SAVE_CHANGES: {
    es: 'Guardar cambios',
    en: 'Save changes',
    cat: 'Desar canvis',
    eus: 'Aldaketak gorde',
    pt: 'Guardar alterações'
  },
  CITY: {
    es: 'Ciudad',
    en: 'City',
    cat: 'Ciutat',
    eus: 'Hiria',
    pt: 'Cidade'
  },
  POSTAL_CODE: {
    es: 'Código postal',
    en: 'Postal code',
    cat: 'Codi postal',
    eus: 'Postal kodea',
    pt: 'Código postal'
  },
  REGION: {
    es: 'Región',
    en: 'Region',
    cat: 'Regió',
    eus: 'Eremua',
    pt: 'Região'
  },
  COUNTRY_CODE: {
    es: 'Código de país',
    en: 'Country code',
    cat: 'Codi de país',
    eus: 'Herrialdearen kodea',
    pt: 'Código de país'
  },
  PHONES: {
    es: 'Teléfonos',
    en: 'Phones',
    cat: 'Telèfons',
    eus: 'Telefonoa',
    pt: 'Telefones'
  },
  NO_INFORMATION_AVAILABLE: {
    es: 'No hay información disponible',
    en: 'No information available',
    cat: 'No hi ha informació disponible',
    eus: 'Ez dago informazioa',
    pt: 'Não há informação disponível'
  },
  THEME: {
    es: 'Tema',
    en: 'Theme',
    cat: 'Tema',
    eus: 'Gaia',
    pt: 'Tema'
  },
  CONFIG_NPS: {
    es: 'NPS',
    en: 'NPS',
    cat: 'NPS',
    eus: 'NPS',
    pt: 'NPS'
  },
  FACEBOOK: {
    es: 'Facebook',
    en: 'Facebook',
    cat: 'Facebook',
    eus: 'Facebook',
    pt: 'Facebook'
  },
  INSTAGRAM: {
    es: 'Instagram',
    en: 'Instagram',
    cat: 'Instagram',
    eus: 'Instagram',
    pt: 'Instagram'
  },
  TIKTOK: {
    es: 'TikTok',
    en: 'TikTok',
    cat: 'TikTok',
    eus: 'TikTok',
    pt: 'TikTok'
  },
  TWITTER: {
    es: 'Twitter',
    en: 'Twitter',
    cat: 'Twitter',
    eus: 'Twitter',
    pt: 'Twitter'
  },
  PREFIX: {
    es: 'Prefijo',
    en: 'Prefix',
    cat: 'Prefijo',
    eus: 'Aurrizko',
    pt: 'Prefixo'
  },
  INFO: {
    es: 'Información',
    en: 'Information',
    cat: 'Informació',
    eus: 'Informazioa',
    pt: 'Informação'
  },
  ADD: {
    es: 'Añadir',
    en: 'Add',
    cat: 'Afegeix',
    eus: 'Gehitu',
    pt: 'Adicionar'
  },
  PHONE: {
    es: 'Teléfono',
    en: 'Phone',
    cat: 'Telèfon',
    eus: 'Telefonoa',
    pt: 'Telefone'
  },
  [EThemeKey.DEFAULT]: {
    es: 'Predeterminado',
    en: 'Default',
    cat: 'Predeterminat',
    eus: 'Lehenetsia',
    pt: 'Padrão'
  },
  [EThemeKey.PRIMARY]: {
    es: 'Primario',
    en: 'Primary',
    cat: 'Primari',
    eus: 'Lehenetsia',
    pt: 'Primário'
  },
  [EThemeKey.DARK]: {
    es: 'Oscuro',
    en: 'Dark',
    cat: 'Fosc',
    eus: 'Lehenetsia',
    pt: 'Escuro'
  },
  NPS_ONBOARDING_DAYS: {
    es: 'Días para mandar el NPS de onboarding',
    en: 'Days to send the onboarding NPS',
    cat: "Dies per enviar el NPS d'onboarding",
    eus: 'Onboarding NPS egiteko egunak',
    pt: 'Dias para enviar o NPS de onboarding'
  },
  NPS_REGULAR_DAYS: {
    es: 'Días para mandar el NPS regular',
    en: 'Days to send the regular NPS',
    cat: 'Dies per enviar el NPS regular',
    eus: 'NPS egiteko egunak',
    pt: 'Dias para enviar o NPS regular'
  },
  THEME_CONFIG: {
    es: 'Configuración del tema',
    en: 'Theme configuration',
    cat: 'Configuració del tema',
    eus: 'Gaiaren konfigurazioa',
    pt: 'Configuração do tema'
  },
  NPS_CONFIG: {
    es: 'Configuración del NPS',
    en: 'NPS configuration',
    cat: 'Configuració del NPS',
    eus: 'NPSaren konfigurazioa',
    pt: 'Configuração do NPS'
  },
  CONTRACT_TEMPLATES: {
    es: 'Contratos',
    en: 'Contracts',
    cat: 'Contractes',
    eus: 'Kontratua',
    pt: 'Contratos'
  },
  CONTRACT_FP: {
    es: 'Contrato FP',
    en: 'FP contract',
    cat: 'Contrato FP',
    eus: 'FPen kontratua',
    pt: 'Contrato FP'
  },
  CONTRACT_DEFAULT: {
    es: 'Contrato por defecto',
    en: 'Default contract',
    cat: 'Contrato per defecte',
    eus: 'Lehenetsiaren kontratua',
    pt: 'Contrato padrão'
  },
  SELECT_CONTRACT: {
    es: 'Seleccionar contrato',
    en: 'Select contract',
    cat: 'Seleccionar contrato',
    eus: 'Kontratua aukeratu',
    pt: 'Selecionar contrato'
  },
  CONTRACT_UNDERAGE: {
    es: 'Contrato para menores de edad',
    en: 'Underage contract',
    cat: "Contrato per menors d'edat",
    eus: 'Minoreen kontratua',
    pt: 'Contrato para menores de idade'
  },
  ADULT_CONTRACT: {
    es: 'Contrato para adultos',
    en: 'Adult contract',
    cat: 'Contrato per adults',
    eus: 'Adultuen kontratua',
    pt: 'Contrato para adultos'
  },
  UNDERAGE_CONTRACT: {
    es: 'Contrato para menores de edad',
    en: 'Underage contract',
    cat: "Contrato per menors d'edat",
    eus: 'Minoreen kontratua',
    pt: 'Contrato para menores de idade'
  },
  REQUIRED_FIELD: {
    es: 'Campo requerido',
    en: 'Required field',
    cat: 'Camp requerit',
    eus: 'Eskariako eremua',
    pt: 'Campo obrigatório'
  },
  CONTRACT_INFO: {
    es: 'Contratos',
    en: 'Contracts',
    cat: 'Contractes',
    eus: 'Kontratua',
    pt: 'Contratos'
  },
  EMAILS: {
    es: 'Emails',
    en: 'Emails',
    cat: 'Emails',
    eus: 'Emailak',
    pt: 'Emails'
  },
  LINKS: {
    es: 'Enlaces',
    en: 'Links',
    cat: 'Enlaces',
    eus: 'Estekak',
    pt: 'Links'
  },
  LINK: {
    es: 'Enlace',
    en: 'Link',
    cat: 'Enlace',
    eus: 'Esteka',
    pt: 'Link'
  }
};
